/**
 * @author PengWen
 * @description 登录实时人数管理
 * @Date 2023/06/21
 */
import React from 'react'
import {component_tool, framework_tool ,utils_tool} from '../../../tool';
let {WizModal, WizDataTable, WizButton} = component_tool;
let { $$ } = utils_tool;

let componentName = 'AuthLoginLog'

const columns = (e) => {
    return [
        {
            name: "id",
            fromItem: {
              type: "hidden"
            }
        },
        {
            title:"PC管理端人数",
            name:"pcManagementCount",
            tableItem: {
                width:70,
                render: (text, record) => (
                    <WizDataTable.Oper>
                      <WizButton tooltip={text}
                        onClick={() => {
                          e.jumpPage && e.jumpPage(
                            'push',
                            '/authLoginLogListDetail',
                            { searchProps: { data: [3] } }
                          )
                        }}>
                        {text}
                      </WizButton>
                    </WizDataTable.Oper>
                )
            },
        },
        {
            title:"PC学员端人数",
            name:"pcStudentCount",
            tableItem: {
                width: 70,
                render: (text, record) => (
                    <WizDataTable.Oper>
                      <WizButton tooltip={text}
                        onClick={() => {
                          e.jumpPage && e.jumpPage(
                            'push',
                            '/authLoginLogListDetail',
                            { searchProps: { data: [4] } }
                          )
                        }}>
                        {text}
                      </WizButton>
                    </WizDataTable.Oper>
                )
            },
        },
        {
            title:"APP人数",
            name:"appCount",
            tableItem: {
                width: 50,
                render: (text, record) => (
                    <WizDataTable.Oper>
                      <WizButton tooltip={text}
                        onClick={() => {
                          e.jumpPage && e.jumpPage(
                            'push',
                            '/authLoginLogListDetail',
                            { searchProps: { data: [6] } }
                          )
                        }}>
                        {text}
                      </WizButton>
                    </WizDataTable.Oper>
                )
            },
        },
        {
            title:"雪佛兰企微人数",
            name:"chevroletWxCount",
            tableItem: {
                width: 70,
                render: (text, record) => (
                    <WizDataTable.Oper>
                      <WizButton tooltip={text}
                        onClick={() => {
                          e.jumpPage && e.jumpPage(
                            'push',
                            '/authLoginLogListDetail',
                            { searchProps: { data: [8] } }
                          )
                        }}>
                        {text}
                      </WizButton>
                    </WizDataTable.Oper>
                )
            },
        },
        {
            title:"别克企微人数",
            name:"buickWxCount",
            tableItem: {
                width: 70,
                render: (text, record) => (
                    <WizDataTable.Oper>
                      <WizButton tooltip={text}
                        onClick={() => {
                          e.jumpPage && e.jumpPage(
                            'push',
                            '/authLoginLogListDetail',
                            { searchProps: { data: [9] } }
                          )
                        }}>
                        {text}
                      </WizButton>
                    </WizDataTable.Oper>
                )
            },
        },
        {
            title:"凯迪拉克企微人数",
            name:"cadillacWxCount",
            tableItem: {
                width: 70,
                render: (text, record) => (
                    <WizDataTable.Oper>
                      <WizButton tooltip={text}
                        onClick={() => {
                          e.jumpPage && e.jumpPage(
                            'push',
                            '/authLoginLogListDetail',
                            { searchProps: { data: [10] } }
                          )
                        }}>
                        {text}
                      </WizButton>
                    </WizDataTable.Oper>
                )
            },
        },
        {
            title:"凯迪拉克IQ企微人数",
            name:"enterpriseCount",
            tableItem: {
                width: 70,
                render: (text, record) => (
                    <WizDataTable.Oper>
                      <WizButton tooltip={text}
                        onClick={() => {
                          e.jumpPage && e.jumpPage(
                            'push',
                            '/authLoginLogListDetail',
                            { searchProps: { data: [7] } }
                          )
                        }}>
                        {text}
                      </WizButton>
                    </WizDataTable.Oper>
                )
            },
        }
    
    ];
}

const templateConfig = (e) => {
    return {
        mainProps: {},
        content: {
            name: 'WizTableList',
            params: {
                columns: columns(e),
                searchBarProps: {
                    buttonSort: [],
                    collapse: false,
                    buttons: []
                },
                modalFormProps: {},
                dataTableProps: {
                    rowKey: 'id',
                    isScroll: true,
                    bordered: false,
                    paging: false,
                    loading: false
                }
            }
        }
    }
}

const apis = {
    list: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {}
      }
    },
}

let reduxTemplateConfig = (args) => {
    return {
        apis,
        componentName,
        initApiKeys: ['list'],
        needLoading: true,
        ...args
    }
};

export {reduxTemplateConfig, templateConfig};